import { combineReducers } from "redux";

import librarySharesReducer from "./library";
import sharelinksReducer from "./sharelinks";

export default combineReducers({
  sharelinks: sharelinksReducer,
  library: librarySharesReducer,
});
